import { IconButton } from '@mui/material';
import React, { FC, MouseEventHandler } from 'react';
import { useStyles } from '../../../theme/styles.helpers';
import { QrCodeButtonStyles } from './QrCodeButton.Styles';
import QrCodeIcon from '@mui/icons-material/QrCode';

interface QrCodeButtonProps {
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const QrCodeButton: FC<QrCodeButtonProps> = ({ type, className, onClick }) => {
  const styles = useStyles(QrCodeButtonStyles, {});

  return (
    <IconButton type={type} className={className} sx={styles.button} onClick={onClick}>
      <QrCodeIcon />
    </IconButton>
  );
};
